import React from "react";
import { Shield, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-12" data-testid="privacy-page">
      <div className="container-main max-w-4xl">
        {/* Back Link */}
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-slate-600 hover:text-sky-600 mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>

        {/* Header */}
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 mb-8">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-sky-500 to-blue-600 flex items-center justify-center">
              <Shield className="w-7 h-7 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-slate-900 font-['Outfit']">Privacy Policy</h1>
              <p className="text-slate-500">Last Updated: March 2026</p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 space-y-8">
          {/* Introduction */}
          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-4">Introduction</h3>
            <p className="mb-4 text-slate-600 leading-relaxed">
              Bundlecart ("we," "our," or "us"), operated as a Sole Trader in Australia, is committed to protecting your privacy. This policy outlines how we handle your information.
            </p>
          </section>

          {/* Data Collection */}
          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-4">Data Collection</h3>
            <p className="mb-4 text-slate-600 leading-relaxed">
              We prioritize data minimization. We only collect your Email Address for the purposes of account management, subscription billing, and order communication. We do not collect your name, phone number, or precise GPS location data.
            </p>
          </section>

          {/* Third-Party Service Providers */}
          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-4">Third-Party Service Providers</h3>
            <p className="mb-4 text-slate-600 leading-relaxed">
              We use third party APIs to provide data. No personal user data (including emails) is shared with these providers. All API requests are handled anonymously.
            </p>
          </section>

          {/* Cookies and Tracking */}
          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-4">Cookies and Tracking</h3>
            <p className="mb-4 text-slate-600 leading-relaxed">
              Bundlecart does not use cookies to track your behavior or remember your session.
            </p>
          </section>

          {/* Data Security */}
          <section>
            <h3 className="text-xl font-semibold text-slate-900 mb-4">Data Security</h3>
            <p className="mb-4 text-slate-600 leading-relaxed">
              We take reasonable steps to protect your email address from unauthorized access or disclosure. As a Sole Trader, we comply with the Australian Privacy Act 1988 where applicable.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
